import React from "react";
import Button from "../includes/button";
import TeamPhoto from "./images/team-members/team-photo-pmg.webp";


class Hero extends React.Component {
    render() {
        return (
            <div className="w-full flex flex-row lg:h-screen mx-auto mt-16 lg:mt-0 p-6 lg:p-24 gap-24 bg-aboutHeroGradient">
                <div className="w-full h-full gap-8 flex lg:flex-row flex-col items-stretch py-10 container mx-auto">
                    <div className="w-full lg:w-1/2 flex-1 text-blue text-left gap-6 flex flex-col items-center justify-center">
                        <h1 className="lg:text-5xl text-3xl pointer-events-none text-blue10 font-bold leading-tight">Why Partnered Management Group?</h1>
                        <p className="lg:text-xl text-base leading-8 pointer-events-none text-grey45 leading-relaxed">
                            We believe great work happens when people feel supported, understood, and equipped with the right resources. Our mission centers on being a hands on partner for small to medium sized businesses covering Project Management, Operations Management, Creative, and Technical execution.
                        </p>
                        {/* self-start so the button hugs the copy; the column is
                            items-center, which would otherwise centre it */}
                        <Button
                            to="/careers"
                            label="View Job Openings"
                            variant="light-primary"
                            isHashLink={false}
                            className="self-start md:!w-56"
                        />
                    </div>
                    {/* object-[40%_50%] keeps the group centred: they sit left of
                        centre in the 3:2 source, so a plain centre crop crowds one end.
                        lg:self-center opts out of the row's items-stretch — with h-auto
                        the item would stretch to lg:h-screen, overriding aspect-square. */}
                    <div className="w-full lg:w-1/2 flex-1 h-auto lg:self-center aspect-square flex justify-center items-center">
                        <img src={TeamPhoto} alt="Partnered Management Group team — PMP-certified project managers and operations leaders" loading="lazy" decoding="async" width="800" height="800" className="w-full h-full object-cover object-[40%_50%] rounded-3xl" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Hero;